import { authDelete } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";

export const deleteDeploymentRepo = (
  deploymentId: string,
  repoPath: string
): Promise<string> => {
  const path = `${DEPLOYMENT_URL}/${deploymentId}/repos/${repoPath}`;
  return authDelete<string>(path);
};
